<script>
    import InputGroup from "../../../../Components/Inputs/InputGroup.vue";

    export default {
        render(createElement){
            /*
                <div class="row form-group">
                    <div class="col-4">
                        <LABEL_TAG>
                    </div>
                    <div class="col-8">
                        <INPUT_GROUP WITH ICON>
                    </div>
                    <div class="col-12">
                        ERRORS
                    </div>
                </div>
             */

            //Take all slot nodes with a tag
            const defaultElementSlots = this.$slots.default.filter(({tag}) => !!tag);

            const labelSlot = createElement('div', {
                class: `col-xl-${this.labelSize} col-lg-12`
            }, [defaultElementSlots[0]]);

            const inputContentSlots = createElement(InputGroup, {
                props: {
                    icon: this.icon
                }
            }, [defaultElementSlots[1]]);

            const inputSlot = createElement('div', {
                class: `col-xl-${this.contentSize} col-lg-12`
            }, [inputContentSlots]);

            const content = [labelSlot, inputSlot];

            //When present; add an element containing all errors to the bottom of our root element
            if(this.$slots.errors){
                content.push(createElement('div', { class: 'col-12' }, [this.$slots.errors]));
            }

            return createElement('div', {
                class: 'row form-group'
            }, content);
        },
        computed: {
            contentSize() {
                return 12 - this.labelSize;
            }
        },
        props: {
            icon: String,
            labelSize: {
                type: Number,
                default: 2,
                validator: (value) => {
                    return value >= 1 && value <= 12;
                }
            }
        }
    };
</script>